import { Body, Box, Icon } from './'
import { assetUrl } from '../../utilities.js'
const audio = new Audio(assetUrl('sounds/cartoon-confirmation-2.wav'))

export const SoundCheck = () => (
  <Box gap={4} onClick={() => audio.play()}>
    <Icon icon="Sound"/>
    <Body underline bold>
      Click here to check sound
    </Body>
  </Box>
)